/** Open consent during the click gesture and retain a safe handle to the tab. */
export async function openConnectionConsent(input: {
  readonly openTab: () => Window | null;
  readonly getUrl: () => Promise<string>;
  readonly navigate: (url: string) => void;
}): Promise<void> {
  const tab = input.openTab();
  // Passing "noopener" to window.open returns null even when the tab opened.
  // Sever the opener ourselves, while keeping the handle needed to navigate it.
  if (tab) tab.opener = null;
  try {
    const url = await input.getUrl();
    if (!URL.canParse(url) || new URL(url).protocol !== "https:") {
      throw new Error("The sign-in link is invalid. Please try again.");
    }
    if (tab && !tab.closed) tab.location.href = url;
    else input.navigate(url);
  } catch (error) {
    tab?.close();
    throw error;
  }
}
